<template>
  <div class="app-container" uk-height-viewport="expand: true">
    <div
      v-if="!error"
      :class="{'my-resource-top-padding': resourcePreview,'top-padding': !resourcePreview}">
      <div v-if="content && !standardsLoading">
        <div class="uk-width-1-1">
          <content-heading
            :sharePreview="sharePreview"
            class="uk-width-2-3@xl uk-width-3-5@m"
            :title="content.detail.title"
            :author="content.detail.author"
          ></content-heading>
        </div>
        <div class="uk-width-1-1 custom-margin grid" uk-grid>
          <div class="uk-width-2-3@xl uk-width-3-5@m ">
            <previewer :activities="previewerList" :EUResource="EUResource" :title="content.detail.title"></previewer>
            <content-information :sharePreview="sharePreview" :device-required="requiresStudentDevices"
                                 :info="content.detail"
                                 :set="standardSet"
                                 :strands="standardStrands"></content-information>
          </div>
          <div class="uk-width-1-3@xl uk-width-2-5@m column-padding">
            <content-delivery
              class="content-delivery"
              uk-sticky="offset: 80"
              :download="download"
              :sharePreview="sharePreview"
              :shareNoteBook="shareNoteBook"
              :EUResource="EUResource"
              :contentDetail="content.detail"
            ></content-delivery>
          </div>
        </div>
      </div>
      <div v-else class="uk-position-center">
        <spinner></spinner>
      </div>
    </div>
    <div v-else>
      <errors :error="error" :large="true" :sharePreview="sharePreview"></errors>
    </div>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
import previewer from './previewer'
import ContentInformation from './content-information'
import ContentDelivery from './content-delivery'
import ContentHeading from './content-heading'
import Spinner from '../ui-components/spinner/spinner'
import Errors from '../content-error/errors'
import keypressUtil from '@/utils/keypress-util'
import { EU_REGION1 } from '../../enums/regions'
import * as event from '@/enums/mixpanel-event'
import metrics from '@/services/metrics'
import deleteModal from '../ui-components/modals/delete-modal'
import mixpanel from '@/services/mixpanel'
import {ROUTE_NAME_PREVIEW, ROUTE_NAME_MYRESOURCE} from '../../enums/routes'
import Environment from '../../plugins/environment'

export default {
  name: 'Preview',
  components: {
    deleteModal,
    Errors,
    Spinner,
    ContentHeading,
    previewer,
    ContentInformation,
    ContentDelivery
  },
  props: {
    download: {
      type: Boolean,
      default: false
    },
    sharePreview: {
      type: Boolean,
      default: false
    },
    shareNoteBook: {
      type: Boolean,
      default: false
    },
    resourceStatus: {
      type: String,
      default: ''
    },
    contentId: {
      type: String,
      default: ''
    },
    resourcePreview: {
      type: Boolean
    }
  },
  data() {
    return {
      content: null,
      previewerList: null,
      error: null,
      requiresStudentDevices: false,
      EUResource: false,
      spinnerFinished: false,
      standardSet: null,
      standardStrands: null,
      standardsLoading: true,
      facebookImagePath: '/static/custom-icons/social-media/facebook-share-image.jpg',
      twitterImagePath: '/static/custom-icons/social-media/twitter-card-image.jpg'
    }
  },
  metaInfo() {
    if (this.content && this.previewRoute) {
      return {
        title: this.content.detail.title,
        meta: [
          { name: 'description',
            content: this.content.detail.description + ' Keywords: ' + this.content.detail.tags.toString()
          },
            {name: 'twitter:card', content: 'summary_large_image'},
            {name: 'twitter:title', content: this.content.detail.title},
            {name: 'twitter:description', content: this.content.detail.description},
            {name: 'twitter:image', content: this.resolveImagePath(this.twitterImagePath)},
            {property: 'og:type', content: 'article'},
            {property: 'og:url', content: window.location.href},
            {property: 'og:title', content: this.content.detail.title},
            {property: 'og:description', content: this.content.detail.description},
            {property: 'og:image', content: this.resolveImagePath(this.facebookImagePath)}
        ]
      }
    } else {
      if (this.content) {
        return {
          title: this.content.detail.title,
          meta: [
            { name: 'robots',
              content: 'noindex'
            }
          ]
        }
      }
    }
  },
  methods: {
    ...mapActions(['resolveStrandData', 'fetchContentDetail', 'fetchResourceShareInfo', 'fetchContentDetailWithBaseUrl']),
    ...mapMutations(['updateCallout']),
    getDetails(id) {
      // mapGetters does not work for functions like this nicely
      return this.$store.getters.getDetails(id)
    },
    renderPreview() {
      if (this.shareNoteBook || this.$route.name === ROUTE_NAME_PREVIEW) {
        this.getShareInfo()
      } else {
        const fetchContentParams = { id: this.$route.params.id, region: Environment.getRegion(), accessToken: this.accessToken }
        this.fetchContentDetail(fetchContentParams)
            .then(() => {
              this.populateData()
              this.resolveStandards()
            })
            .catch(error => {
              metrics.sendMetric(
                  metrics.CATEGORIES.THIRD_PARTY_CALLS,
                  metrics.CP_TAGS.FETCH_SHARE_INFO_ERROR,
                  1,
                  metrics.TYPE.FAILURE_COUNTER,
                  error
                )
              this.error = error
            })
      }
    },
    getShareInfo() {
      this.fetchResourceShareInfo(this.$route.params.id)
        .then(shareInfo => {
          shareInfo.region.toLowerCase() === EU_REGION1 ? this.EUResource = true : this.EUResource = false
          this.getContentDetail(shareInfo)
        })
      .catch(error => {
        metrics.sendMetric(
          metrics.CATEGORIES.THIRD_PARTY_CALLS,
          metrics.CP_TAGS.FETCH_CONTENT_DETAIL_ERROR,
          1,
          metrics.TYPE.FAILURE_COUNTER,
          error
        )
        this.error = error
      })
    },
    getContentDetail(shareInfo) {
      this.fetchContentDetailWithBaseUrl(shareInfo)
      .then(() => {
        this.populateData()
        this.resolveStandards()
      })
      .catch(error => {
        metrics.sendMetric(
          metrics.CATEGORIES.THIRD_PARTY_CALLS,
          metrics.CP_TAGS.FETCH_CONTENT_DETAIL_ERROR,
          1,
          metrics.TYPE.FAILURE_COUNTER,
          error
        )
        this.error = error
      })
    },
    resolveStandards() {
      if (
        this.content.detail.standardSets &&
        this.content.detail.standardSets.length > 0
      ) {
        let set = this.content.detail.standardSets[0]
        let strands = []
        return this.resolveStrandData(this.content.detail.standardStrands)
          .then(response => {
            for (let strand of response) {
              let strandObj = {
                title:
                  strand.body.standard_number +
                  '  ' +
                  strand.body.standard_text,
                guid: strand.body.guid,
                standard: strand.body.standard_number.trim(),
                description: strand.body.standard_text.trim()
              }
              strands.push(strandObj)
            }
            this.standardSet = this.getStandards.find(x => x.id === set).title
            this.standardStrands = strands
            this.standardsLoading = false
          })
          .catch(() => {
            this.standardsLoading = false
          })
      }
      this.standardsLoading = false
    },
    populateData() {
      this.content = this.getDetails(this.$route.params.id)
      this.previewerList = this.content.detail.previewerList
      this.requiresStudentDevices = this.content.detail.requiresStudentDevices
      if (this.sharePreview || this.shareNoteBook) {
        // separating resource/sharelink preview data collection
        let eventProps = { contentId: this.$route.params.id, shareLink: true }
        mixpanel.track(event.RESOURCE_PREVIEWED, eventProps)
      } else {
        mixpanel.track(event.RESOURCE_PREVIEWED, {
          contentId: this.$route.params.id
        })
      }
    },
    resolveImagePath(path) {
      return window.location.origin + path
    }
  },
  created() {
    if (this.$route.name === ROUTE_NAME_MYRESOURCE && !this.authenticated) {
      let state = {
        from: this.$route.path,
        download: false
      }
      this.$auth.id.signIn(state)
    } else {
      if (this.resourceStatus) {
        this.updateCallout(false)
      }
      this.renderPreview()
    }
  },
  beforeRouteLeave(to, from, next) {
    keypressUtil.removeListeners()
    next()
  },
  computed: {
    ...mapGetters(['getStandards', 'accessToken']),
    ...mapGetters('auth/id', ['authenticated']),
    previewRoute() {
      return this.$route.name === ROUTE_NAME_PREVIEW
    }
  },
  watch: {
    $route: function(value) {
      if (this.content.contentId !== value.params.id) {
        this.content = null
        this.renderPreview()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../styles/breakpoints';

.uk-first-column {
  padding-left: 0;
}

.uk-grid {
  margin-left: 0;
}

.column-padding {
  padding-left: 0;
}

.custom-margin {
  margin-top: 16px;
}

.content-delivery {
  z-index: 0;
}

.top-padding {
  padding-top: 115px;
}

.my-resource-top-padding {
  padding-top: 24px;
}

@media screen and (min-width: $breakpoint-medium) {
  .column-padding {
    padding-left: 24px;
  }

  .top-padding {
    padding-top: 86px;
  }
}

@media screen and (max-width: $breakpoint-medium) {
  .app-container {
    width: 100%;
  }
}
</style>
